import { Link } from 'react-router-dom'
import Back from '../../assets/icons/Back'
import Logo from '../../assets/images/supunnisalalogo.png';
import SubFooter from '../../lib/footer/SubFooter';
import CardsDesigns from '../../components/Cards/Cards';

function Design() {
    return(
        <main className=''>
            <div>
                <div className=''>
                    <div className='flex flex-row bg-white items-center h-14 align-middle justify-between border border-b-2' >
                        <div>
                        <Link to='/' className='flex flex-row ml-4 md:ml-14 align-middle justify-items-center hover:fill-amber-700 hover:text-amber-700' >
                            <span className='flex justify-items-center' ><Back /></span>
                            <p className='ml-2 font-mono font-medium text-sm uppercase '>homepage</p>
                        </Link>
                        </div>
                        <div className='mr-8 md:mr-14'>
                            <img src={Logo} className='w-7' alt='makaranda'></img>
                        </div>
                    </div>
                    <div className='container m-auto'>
                        <div className='flex flex-col justify-center'>
                            <div className='mt-10' ><h3 className='font-Marisa text-center text-3xl' >Art Works</h3></div>
                            <div><p className='font-Arial text-gray-500 text-lg md:text-xl font-regular break-words mt-1 md:mt-3 text-center p-3'>
                                What's Art & Design? Any creative human activity can arguably be defined as art. Here are some of sketchers done. 
                            </p></div>
                        </div>
                    </div>
                    <div className='mt-20'>
                    </div>
                </div>
                <CardsDesigns />
            </div>
            <SubFooter />
        </main>
    )
}

export default Design;
